var _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 598,
    height: 320,
    viewBox: "0 0 598 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 598,
    height: 320,
    rx: 24,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 598,
    height: 320,
    rx: 24,
    fill: "url(#paint0_linear_171867_5807)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_171867_5807",
    x1: 622.992,
    y1: 0.0000332214,
    x2: 156.312,
    y2: 542.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#335CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322435,
    stopColor: "#182F8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641117,
    stopColor: "#335CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.954845,
    stopColor: "#1F3BAD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImg);
export default __webpack_public_path__ + "static/media/default_img.d9bcf2ab88c7f4ad7065c480fc907b11.svg";
export { ForwardRef as ReactComponent };